import React, { useRef } from 'react';
import { Button, Input } from 'antd';
import clsx from 'clsx';
import { EmailSubscription } from 'src/components/common/EmailSubscription'
import { Details } from '../types/AlertConfiguration';
import { MonitoredSegments } from './MonitoredSegments';

import styles from './BlockDetails.module.less';

const { TextArea } = Input;

export type DetailsValidation = {
  hasErrors: boolean;
  hasChanges: boolean;
};

type PropsBlockDetails = {
  details: Details;
  setDetails: (details: Details) => void;
  isSaveDisabled: (details: DetailsValidation) => boolean;
  onSave: () => void;
};

export const BlockDetails: React.FC<PropsBlockDetails> = ({ details, setDetails, isSaveDisabled, onSave }) => {
  const initialDetails = useRef<Details>(details);
  const setName = (value: string) => {
    setDetails({
      ...details,
      name: value,
    });
  };

  const setDescription = (value: string) => {
    setDetails({
      ...details,
      description: value,
    });
  };

  const isDisabled = isSaveDisabled({
    hasErrors: !details.name,
    hasChanges: initialDetails.current !== details,
  });

  return (
    <div className={clsx(styles.blockDetails, 'box')}>
      <div className={clsx(styles.blockInputDetails, styles.withBottomBorder)}>
        <h2>Settings</h2>
      </div>
      <div className={styles.blockInputDetails}>
        <h4 className={clsx(styles.label, styles.required)}>Alert Name</h4>
        <Input type="text" value={details.name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className={styles.blockInputDetails}>
        <h4 className={styles.label}>Alert Description</h4>
        <TextArea value={details.description} onChange={(e) => setDescription(e.target.value)} />
      </div>
      <div className={styles.blockInputDetails}>
        <h4 className={styles.label}>Monitored Segments</h4>
        <MonitoredSegments
          segmentIds={details.segmentIds}
          setSegmentIds={(segmentIds) => setDetails({ ...details, segmentIds })}
        />
      </div>
      <div className={styles.blockInputDetails}>
        <h4 className={styles.label}>Email Subscription</h4>
        <EmailSubscription
          subscriptions={details.subscriptions.filter(Boolean)}
          setSubscribers={(subscriptions) => setDetails({ ...details, subscriptions })}
        />
      </div>
      <Button type="primary" className={styles.button} disabled={isDisabled} onClick={onSave}>
        Save
      </Button>
    </div>
  );
};
